module.exports = __webpack_public_path__ + "img/bg_personal@2x.54a118c8.png";